import { memo, useMemo } from 'react';
import { usePatientOnly } from '../../../../hooks/useBreakPoint';

import { useDynamicStyle } from '../../../../hooks/useDynamicStyle';
import '../../../../css/patient-detail.css';
import * as Icons from '../../../../images/icons/icons_component';

const JrNaeYeokDetail = memo(({ dataList, isDetailToggle }) => {

    const PTMI = dataList.PTMI;

    const DGOT = dataList.DGOT;

    const OPPT = dataList.OPPT;

    const DGDC = dataList.DGDC;

    const KTDT = dataList.KTDT;

    const SDMD = dataList.SDMD;

    const TRPT = dataList.TRPT;

    const protectiveList = useMemo(() => [
        { title: '안전벨트', code: PTMI?.PTMITSBT },
        { title: '아동용좌석', code: PTMI?.PTMITSCS },
        { title: '전면에어백', code: PTMI?.PTMITSFA },
        { title: '측면에어백', code: PTMI?.PTMITSSA },
        { title: '헬멧', code: PTMI?.PTMITSHM },
        { title: '무릎/관절보호대', code: PTMI?.PTMITSPT },
        { title: '기타(구명조끼 등)', code: PTMI?.PTMIETCT },
        { title: '전혀착용안함', code: PTMI?.PTMITSNO },
        { title: '비해당', code: PTMI?.PTMITSUR },
        { title: '미상', code: PTMI?.PTMITSUK },
    ], [PTMI]);

    const patientOnly = usePatientOnly();

    // Dynamic Style Hook
    const { fontColor, subTitleBorder, lightBackColor } = useDynamicStyle();

    return (
        <div className='detail_container'>
            {!PTMI ?
                <>
                    <div className='flex flex-row'>
                        <Icons.NoticeIco />
                        <span className='content-center bold'>환자를 검색 후, 상세 조회를 확인할 환자를 선택해주세요.</span>
                    </div>
                    <span className={`data_empty h-full justify-center ${lightBackColor}`}>
                        <Icons.NullDalgu />대상환자를 선택해주세요!
                    </span>
                </>
                :
                <>
                    <div className='flex gap-1'>
                        {PTMI.PTMISEXDESC === "M" ? <Icons.FaceDalgu16 /> : <Icons.FaceSalgu16 />}
                        <div className='items-center bold flex gap-1'>
                            <span>{PTMI.PTMINAME}&ensp;{PTMI.AGE.slice(1, 3)}세&nbsp;{PTMI.PTMISEXDESC === "M" ? "(남)" : "(여)"}</span>
                            <span className='co_gray'>/</span>
                            <span className='co_red'>[ {PTMI.PTMIMNSYPRTM || '-'} / {PTMI.PTMISYM2PRTM || '-'} / {PTMI.PTMISYM3PRTM || '-'} ]</span>
                        </div>
                    </div>
                    <div className={`detail_wrapper ${isDetailToggle && !patientOnly && 'flex gap-4'}`}>
                        <div className={`detail_section ${isDetailToggle ? 'pr-1' : ''}`}>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;1. 환자 상세정보</div>
                                <table>
                                    <colgroup>
                                        <col width='112px' />
                                        <col width='120px' />
                                        <col width='112px' />
                                        <col width='120px' />
                                        <col width='70px' />
                                        <col width='115px' />
                                        <col width='90px' />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th rowSpan={2}>환자신상정보</th>
                                            <th>의무기록번호<br /><span className='text-xs medium'>(환자번호)</span></th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIMASK}</td>
                                            <th>성명</th>
                                            <td colSpan={1}>{!PTMI ? "-" : PTMI.PTMINAME}</td>
                                            <th>연령 <span className='co_red'>*</span> / 성별 <span className='co_red'>*</span></th>
                                            <td colSpan={2} className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIBRXX}</td>
                                        </tr>
                                        <tr>
                                            <th>우편번호</th>
                                            <td colSpan={6}>{!PTMI ? "-" : PTMI.PTMIZIPC}</td>
                                        </tr>
                                        <tr>
                                            <th rowSpan={2}>의료기관정보</th>
                                            <th>응급의료기관코드</th>
                                            <td colSpan={1}>{!PTMI ? "-" : PTMI.PTMIEMCD}</td>
                                            <th colSpan={1}>요양기관번호<span className='co_red'>*</span></th>
                                            <td colSpan={4} className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIHSCD}</td>
                                        </tr>
                                        <tr>
                                            <th>보험유형<span className='co_red'>*</span></th>
                                            <td colSpan={1} className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIIUKDDESC}</td>
                                            <th colSpan={1}>진료의사면허번호</th>
                                            <td colSpan={4} >{!PTMI ? "-" : PTMI.PTMIDRLC}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;2. 환자 내원정보</div>
                                <table>
                                    <colgroup>
                                        <col width='115px' />
                                        <col width='230px' />
                                        <col width='120px' />
                                        <col width='260px' />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>발병일시<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIAKDT} / {!PTMI ? "-" : PTMI.PTMIAKTM}</td>
                                            <th>내원일시</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIINDT} / {!PTMI ? "-" : PTMI.PTMIINTM}</td>
                                        </tr>
                                        <tr>
                                            <th>내원경로<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI || !PTMI.PTMIINRTDESC ? "-" : PTMI.PTMIINRTDESC}</td>
                                            <th>내원수단<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIINMNDESC}</td>
                                        </tr>
                                        <tr>
                                            <th>질병여부</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIDGKDDESC}</td>
                                            <th>전원 보낸 의료기관 <br />종류 / 코드<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIINTPDESC} {!PTMI ? "-" : PTMI.PTMIINCD}</td>
                                        </tr>
                                        <tr>
                                            <th colSpan={1}>의도성여부</th>
                                            <td colSpan={3}>{!PTMI || !PTMI.PTMIARCFDESC ? "-" : PTMI.PTMIARCFDESC}</td>
                                        </tr>
                                        <tr>
                                            <th>손상기전</th>
                                            <td colSpan={3}>{!PTMI || !PTMI.PTMIARCSDESC ? "-" : PTMI.PTMIARCSDESC}</td>
                                        </tr>
                                        {!PTMI ? "" : PTMI.viewLimit === 'Y' && (<tr>
                                            <th colSpan={2}>병원 전 단계_수용곤란 고지 중 환자수용</th>
                                            <td colSpan={2}>{PTMI.PTMINODA}</td>
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;3. 환자 초기평가정보</div>
                                <table>
                                    <colgroup>
                                        <col width='98px' />
                                        <col width='79px' />
                                        <col width='81px' />
                                        <col />
                                        <col width='84px' />
                                        <col width='78px' />
                                        <col width='61px' />
                                        <col />
                                        <col width='81px' />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th rowSpan={3}>주증상<span className='co_red'>*</span></th>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMIMNSY}</td>
                                            <td colSpan={3}>{!PTMI ? "-" : PTMI.PTMIMNSYPRTM}</td>
                                            <td colSpan={4}>{!PTMI ? "-" : PTMI.PTMIMNSYCHCO}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMISYM2}</td>
                                            <td colSpan={3}>{!PTMI || !PTMI.PTMISYM2PRTM ? "-" : PTMI.PTMISYM2PRTM}</td>
                                            <td colSpan={4}>{!PTMI || !PTMI.PTMISYS2CHCO ? "-" : PTMI.PTMISYS2CHCO}</td>
                                        </tr>
                                        <tr>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMISYM3}</td>
                                            <td colSpan={3}>{!PTMI || !PTMI.PTMISYM3PRTM ? "-" : PTMI.PTMISYM3PRTM}</td>
                                            <td colSpan={4}>{!PTMI || !PTMI.PTMISYS3CHCO ? "-" : PTMI.PTMISYS3CHCO}</td>
                                        </tr>
                                        <tr>
                                            <th>기타증상</th>
                                            <td colSpan={3}>{!PTMI ? "-" : PTMI.PTMIETSY}</td>
                                            <th>내원시반응<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIRESPDESC}</td>
                                            <th colSpan={2}>응급증상해당여부<span className='co_red'>*</span></th>
                                            <td colSpan={2} className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIEMSY} </td>
                                        </tr>
                                        <tr>
                                            <th>수축/이완혈압</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIHIBP} / {!PTMI ? "-" : PTMI.PTMILOBP}</td>
                                            <th>분당맥박수</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIPULS}</td>
                                            <th>분당호흡수</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIBRTH}</td>
                                            <th>체온</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIBDHT}</td>
                                            <th>산소포화도</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIVOXS}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;4. 환자 응급진료 내용 및 결과</div>
                                <table>
                                    <colgroup>
                                        <col width='105px' />
                                        <col />
                                        <col width='110px' />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>주진료과<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI || !PTMI.PTMIDEPTDESC ? "-" : PTMI.PTMIDEPTDESC}</td>
                                            <th>퇴실일시<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI ? "-" : PTMI.PTMIOTDT} / {!PTMI ? "-" : PTMI.PTMIOTTM}</td>
                                        </tr>
                                        <tr>
                                            <th>응급진료결과<span className='co_red'>*</span></th>
                                            <td className='co_red bold'>{!PTMI || !PTMI.PTMIEMRTDESC ? "-" : PTMI.PTMIEMRTDESC}</td>
                                            <th>기타사유</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIETTX}</td>
                                        </tr>
                                        <tr>
                                            <th colSpan={1}>전원 보낼<br /> 의료기관 종류/코드</th>
                                            {!PTMI ? '' : PTMI.PTMIDCRT !== '3' && PTMI.PTMIDCRT !== '21' && PTMI.PTMIDCRT !== '22' && PTMI.PTMIDCRT !== '23' && PTMI.PTMIDCRT !== '24' && PTMI.PTMIDCRT !== '28' ?
                                                (<td colSpan={3}>{PTMI.PTMIDCTPDESC}&nbsp;{PTMI.PTMIDCCD}</td>) : (<td colSpan={3}> - </td>)}
                                        </tr>
                                        <tr>
                                            <th>퇴실진단명<span className='co_red'>*</span></th>
                                            <td colSpan={3}>
                                                <div className='inner_table'>
                                                    <table>
                                                        <colgroup>
                                                            <col width="15%" />
                                                            <col width="35%" />
                                                            <col width="35%" />
                                                            <col width="15%" />
                                                            <col width="15%" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>진단코드</th>
                                                                <th>진단코드명</th>
                                                                <th>진단코드 설명</th>
                                                                <th>일련번호</th>
                                                                <th>진단구분</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!DGOT ? (<tr>
                                                                <td align="center">-</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td align="center">-</td>
                                                                <td align="center">-</td>
                                                            </tr>) : DGOT.map((content, index) => (
                                                                <tr key={index}>
                                                                    <td align="center" className='co_red bold'>{content.DGOTDIAG}</td>
                                                                    <td>{content.DIAGNAME}</td>
                                                                    <td>{content.DIAGDESC}</td>
                                                                    <td align="center">{content.DGOTSERL}</td>
                                                                    <td align="center">{content.DGGBDESC}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>응급실내 검사<br />처치/수술 내역</th>
                                            <td colSpan={3}>
                                                <div className='inner_table'>
                                                    <table>
                                                        <colgroup>
                                                            <col width="18%" />
                                                            <col width="60%" />
                                                            <col width="32%" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>처치코드</th>
                                                                <th>처치코드 설명</th>
                                                                <th>검사/처치/수술시작일시</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!TRPT ? (<tr>
                                                                <td align="center">-</td>
                                                                <td>-</td>
                                                                <td align="center">-</td>
                                                            </tr>) : TRPT.map((content, index) => (
                                                                <tr key={index}>
                                                                    <td align="center">{content.TRPTTRCD}</td>
                                                                    <td>{content.TRCDDESC}</td>
                                                                    <td align="center">{content.TRPTTRST}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className={`detail_section ${patientOnly && 'mt-4'} ${isDetailToggle ? 'pr-1' : 'mt-4'}`}>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;5. 교통사고 진료 결과</div>
                                <table>
                                    <colgroup>
                                        <col width="81px" />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>손상당사자</th>
                                            <td className='text-left'>
                                                <select name="PTMI" value={!PTMI ? "-" : PTMI.PTMITAIP} disabled={PTMI?.PTMITAIP === '-'}>
                                                    <option value="-">선택</option>
                                                    <option value="1" disabled="disabled">보행자</option>
                                                    <option value="2" disabled="disabled">운전자</option>
                                                    <option value="3" disabled="disabled">승객</option>
                                                    <option value="4" disabled="disabled">기타</option>
                                                    <option value="9" disabled="disabled">미상</option>
                                                </select>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>보호장구<span className='co_red'>*</span></th>
                                            <td>
                                                <div className='flex flex-row flex-wrap'>
                                                    {protectiveList.map((item, idx) =>
                                                        <div key={idx} className='flex co_dark w-32'>
                                                            {item.code === 'Y' ? <Icons.CheckOk /> : <Icons.CheckNon />}
                                                            <label className='cursor-default'>{item.title}</label>
                                                        </div>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;6. 최종 진료결과 (응급실 경유 입원환자)</div>
                                <table>
                                    <colgroup>
                                        <col width="105px" />
                                        <col />
                                        <col width="120px" />
                                        <col />
                                        <col width="120px" />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>입원후 결과</th>
                                            <td>{!PTMI || !PTMI.PTMIDCRTDESC ? "-" : PTMI.PTMIDCRTDESC}</td>
                                            <th>입원일시</th>
                                            <td>{!PTMI || !PTMI.PTMIHSDT ? "-" : PTMI.PTMIHSDT} / {!PTMI || !PTMI.PTMIHSTM ? "-" : PTMI.PTMIHSTM}</td>
                                            <th>퇴원일시</th>
                                            <td>{!PTMI || !PTMI.PTMIDCDT ? "-" : PTMI.PTMIDCDT} / {!PTMI || !PTMI.PTMIDCTM ? "-" : PTMI.PTMIDCTM}</td>
                                        </tr>
                                        <tr>
                                            <th colSpan={1}>전원 보낼 <br />의료기관 종류/코드</th>
                                            {!PTMI ? '' : PTMI.PTMIDCRT === '3' || PTMI.PTMIDCRT === '21' || PTMI.PTMIDCRT === '22' || PTMI.PTMIDCRT === '23' || PTMI.PTMIDCRT === '24' || PTMI.PTMIDCRT === '28' ?
                                                (<td colSpan={5}>{PTMI.PTMIDCTPDESC}&nbsp;{PTMI.PTMIDCCD}</td>) : (<td colSpan={5}> - </td>)}
                                        </tr>
                                        <tr>
                                            <th>입원 후 검사<br />처치/수술내역</th>
                                            <td colSpan={5}>
                                                <div className='inner_table'>
                                                    <table>
                                                        <colgroup>
                                                            <col width="18%" />
                                                            <col width="60%" />
                                                            <col width="32%" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>처치코드</th>
                                                                <th>처치코드 설명</th>
                                                                <th>검사/처치/수술시작일시</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!OPPT ? (<tr>
                                                                <td align="center">-</td>
                                                                <td>-</td>
                                                                <td align="center">-</td>
                                                            </tr>)
                                                                : OPPT.map((content, index) => (
                                                                    <tr key={index}>
                                                                        <td align="center">{content.OPPTOPCD}</td>
                                                                        <td>{content.TRCDDESC}</td>
                                                                        <td align="center">{content.OPPTOPDT}&nbsp;{content.OPPTOPTM}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>퇴원진단명</th>
                                            <td colSpan={5}>
                                                <div className='inner_table'>
                                                    <table>
                                                        <colgroup>
                                                            <col width="15%" />
                                                            <col width="35%" />
                                                            <col width="35%" />
                                                            <col width="15%" />
                                                            <col width="15%" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>진단코드</th>
                                                                <th>진단코드명</th>
                                                                <th>진단코드 설명</th>
                                                                <th>일련번호</th>
                                                                <th>진단구분</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!DGDC ? (<tr>
                                                                <td align="center">-</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td align="center">-</td>
                                                                <td align="center">-</td>
                                                            </tr>) : DGDC.map((content, index) => (
                                                                <tr key={index}>
                                                                    <td align="center">{content.DGDCDIAG}</td>
                                                                    <td>{content.DIAGNAME}</td>
                                                                    <td>{content.DIAGDESC}</td>
                                                                    <td align="center">{content.DGDCSERL}</td>
                                                                    <td align="center">{content.DGGBDESC}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;7. 중증도 분류</div>
                                <table>
                                    <colgroup>
                                        <col width="80px" />
                                        <col width="60px" />
                                        <col width="60px" />
                                        <col width="60px" />
                                        <col width="60px" />
                                        <col width="60px" />
                                        <col width="60px" />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th>중증도 분류 선별번호</th>
                                            <td colSpan={6}>{!PTMI ? "-" : PTMI.PTMIKTID}</td>
                                        </tr>
                                        <tr>
                                            <th rowSpan={3}>최초 중증도 분류</th>
                                            <th>일시</th>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMIKTDT}&nbsp;{!PTMI ? "" : PTMI.PTMIKTTM}</td>
                                            <th>결과</th>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMIKTS1DESC} ({!PTMI ? "-" : PTMI.PTMIKTS1})</td>
                                        </tr>
                                        <tr>
                                            <th>과정</th>
                                            <td colSpan={5}>{!PTMI ? "-" : PTMI.PTMIKPR1} ({!PTMI ? "-" : PTMI.PTMIKPR1CD})</td>
                                        </tr>
                                        <tr>
                                            <th>분류자직종</th>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMIKJOBDESC}</td>
                                            <th>분류자 면허<br />또는 자격번호</th>
                                            <td colSpan={2}>{!PTMI ? "-" : PTMI.PTMIKIDN}</td>
                                        </tr>
                                        <tr>
                                            <th rowSpan={2}>변경된 중증도 분류</th>
                                            <th>과정</th>
                                            <td colSpan={5}>{!PTMI ? "-" : PTMI.PTMIKPR2} ({!PTMI ? "-" : PTMI.PTMIKPR2CD})</td>
                                        </tr>
                                        <tr>
                                            <th>결과</th>
                                            <td colSpan={5}>{!PTMI ? "-" : PTMI.PTMIKTS2DESC} ({!PTMI ? "-" : PTMI.PTMIKTS2})</td>
                                        </tr>
                                        <tr>
                                            <th>최종진료구역</th>
                                            <td colSpan={2}>{!PTMI || !PTMI.PTMIAREADESC ? "-" : PTMI.PTMIAREADESC}</td>
                                            <th colSpan={2}>입원 경로</th>
                                            <td colSpan={2}>{!PTMI || !PTMI.PTMIHSRTDESC ? "-" : PTMI.PTMIHSRTDESC}</td>
                                        </tr>
                                        {!KTDT ? '' : KTDT && (KTDT.PTMIGRDC === 'A' || KTDT.PTMIGRDC === 'C' || KTDT.PTMIGRDC === 'E') ?
                                            (<tr>
                                                <th>최초 전송 시간</th>
                                                <td colSpan={2}>{KTDT.PTMIWKDT}&nbsp;{KTDT.PTMIWKTM}</td>
                                                <th colSpan={2}>격리구역 병상번호</th>
                                                <td colSpan={2}>{PTMI.PTMIBENO}</td>
                                            </tr>)
                                            : (<tr>
                                                <th colSpan={2}>최초 전송 시간</th>
                                                <td colSpan={2}>-</td>
                                                <th colSpan={2}>격리구역 병상번호</th>
                                                <td colSpan={2}>-</td>
                                            </tr>)}
                                    </tbody>
                                </table>
                            </div>
                            <div className='table_section'>
                                <div className={`detail_title ${subTitleBorder} ${fontColor}`}>&ensp;8. 전문의 진료과목</div>
                                <table>
                                    <colgroup>
                                        <col width="110px" />
                                        <col width="80px" />
                                        <col />
                                    </colgroup>
                                    <tbody>
                                        <tr>
                                            <th colSpan={2}>주된 진료를 받은 응급의료센터</th>
                                            <td>{!PTMI ? "-" : PTMI.PTMIMDCD}. {!PTMI || !PTMI.PTMIMDCDDESC ? "-" : PTMI.PTMIMDCDDESC}</td>
                                        </tr>
                                        <tr>
                                            <th>전문의 진료 여부</th>
                                            <td colSpan={2}>{!PTMI || !PTMI.PTMISDCDDESC ? "-" : PTMI.PTMISDCDDESC}</td>
                                        </tr>
                                        <tr>
                                            <th>전문의 진료 내역</th>
                                            <td colSpan={2}>
                                                <div className='inner_table'>
                                                    <table>
                                                        <colgroup>
                                                            <col width="10%" />
                                                            <col width="15%" />
                                                            <col width="25%" />
                                                            <col width="20%" />
                                                            <col width="20%" />
                                                        </colgroup>
                                                        <thead>
                                                            <tr>
                                                                <th>진료코드</th>
                                                                <th>진료과목코드명</th>
                                                                <th>전문의 진료과목 구분</th>
                                                                <th>전문의 의사 면허 번호</th>
                                                                <th>전문의 진료 일시</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {!SDMD ? (<tr>
                                                                <td align="center">-</td>
                                                                <td>-</td>
                                                                <td>-</td>
                                                                <td align="center">-</td>
                                                                <td align="center">-</td>
                                                            </tr>) : SDMD.map((content, index) => (
                                                                <tr key={index}>
                                                                    <td align="center">{content.SDMDDEPT}</td>
                                                                    <td>{content.SDMDDEPTDESC}</td>
                                                                    <td>{content.SDMDDIVIDESC}</td>
                                                                    <td align="center">{content.SDMDDRLC}</td>
                                                                    <td align="center">{content.SDMDSDDT}&nbsp;{content.SDMDSDTM}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div >
    )
});

export default JrNaeYeokDetail;